/**
 * Get cookie options based on the current context.
 * When accessing via HTTP (e.g., internal IP), secure must be false.
 * When accessing via HTTPS or localhost, secure can be true.
 */
export const getCookieOptions = (expires = 365) => {
  const isSecureContext =
    window.location.protocol === 'https:' ||
    window.location.hostname === 'localhost'

  return {
    sameSite: isSecureContext ? 'none' : 'lax',
    secure: isSecureContext,
    expires,
  }
}

export const getSessionCookieOptions = () => getCookieOptions(undefined)

